module.exports = __webpack_public_path__ + "img/report.4e15add2.svg";